module.exports = __webpack_public_path__ + "static/img/sgyu.ab5c966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgyu.png
// module id = Y35F
// module chunks = 0